<template>
  <div class="content">
    <div class="cont_box">
      <!-- 标题 -->
      <div class="cont_head">
        <h2>鉴定评估复核：</h2>
      </div>
      <!-- 分割线 -->
      <div class="bord"></div>
      <div class="cont_bo">
        <div class="cont_b">
          <div class="cont_contes">
            <div class="cons_cos">
              <div class="cont_lefts">
                <h3>
                  当户：<el-input
                    type="text"
                    placeholder="请输入当户姓名"
                    v-model="input_jnames"
                    maxlength="5"
                    clearable
                    class="con_texts"
                  >
                  </el-input>
                </h3>
                <h3>
                  地址：<el-input
                    type="text"
                    placeholder="请输入当户证件地址"
                    v-model="input_jadds"
                    clearable
                    class="con_texts"
                  >
                  </el-input>
                </h3>
                <h3>
                  证件类型：
                  <el-radio v-model="radiojs" label="身份证" border>身份证</el-radio>
                  <el-radio v-model="radiojs" label="其他" border>其他</el-radio>
                </h3>
              </div>
              <div class="cont_rights">
                <h3>
                  电话：<el-input
                    type="number"
                    placeholder="请输入当户电话"
                    v-model="input_jtels"
                    maxlength="11"
                    clearable
                    class="con_texts"
                  >
                  </el-input>
                </h3>
                <h3>
                  物品名称：<el-input
                    type="text"
                    placeholder="请输入物品名称"
                    v-model="input_jwus"
                    clearable
                    class="con_texts"
                  >
                  </el-input>
                </h3>
                <h3>
                  证件号码：
                  <el-input
                    type="number"
                    placeholder="请输入证件号码"
                    v-model="input_jidcards"
                    maxlength="18"
                    clearable
                    class="con_texts"
                  >
                  </el-input>
                </h3>
              </div>
            </div>

            <!-- 输入值 -->
            <div class="tables">
              <div class="tab_item">
                <h3>当物名称：</h3>
                <el-input
                  placeholder="请输入名称"
                  v-model="tabs_jinputs"
                  clearable
                  class="tables_inps"
                >
                </el-input>
              </div>
              <div class="tab_item">
                <h3>规格：</h3>
                <el-input
                  placeholder="请输入规格"
                  v-model="tabs_jinpus"
                  clearable
                  class="tables_inps"
                ></el-input>
              </div>
              <div class="tab_item">
                <h3>数量：</h3>
                <el-input
                  type="number"
                  placeholder="请输入数量"
                  v-model="tabs_jinps"
                  clearable
                  class="tables_inps"
                ></el-input>
              </div>
              <div class="tab_item">
                <h3>重量/g：</h3>
                <el-input
                  placeholder="请输入重量"
                  v-model="tabs_jins"
                  clearable
                  class="tables_inps"
                ></el-input>
              </div>
              <div class="tab_item">
                <h3>鉴定备注：</h3>
                <el-input
                  placeholder="请输入备注"
                  v-model="tabs_jis"
                  clearable
                  class="tables_inps"
                ></el-input>
              </div>
            </div>

            <!-- 鉴定日期 -->
            <div class="conts_zf">
              <h3>鉴定日期: {{ deta }}</h3>
              <h3>已收鉴定费:</h3>
              <el-input
                placeholder="请输入鉴定费"
                v-model="inputjd"
                clearable
                class="cont_jdf"
              >
              </el-input>
            </div>
          </div>
          <!-- 经办信息 -->
          <div class="cont_jb">
            <span
              ><h3>经办人：{{ agent }}</h3></span
            >

            <!-- 复核 -->
            <span class="cont_jbs">
              <h3>复核：{{ review }}</h3>
            </span>

            <!-- 财务 -->
            <span class="cont_jbs">
              <h3>财务：{{ finance }}</h3>
            </span>
          </div>

          <!-- 提交按钮 -->
          <div class="foter">
            <el-button type="primary" @click="cont_Submitjs">复核提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "appraisal",

  data() {
    return {
      ACCESS_TOKEN: "", //请求回来的ACCESS_TOKEN
      id: "", //id
      input_jnames: "", //当户姓名
      input_jadds: "", //当户证件地址
      radiojs: "", //证件类型
      input_jtels: "", //当户电话
      input_jwus: "", //物品名称
      input_jidcards: "", //证件号码
      tabs_jinputs: "", //当物名称
      tabs_jinpus: "", //规格
      tabs_jinps: "", //数量
      tabs_jins: "", //重量
      tabs_jis: "", //鉴定备注
      deta: "", //鉴定日期
      inputjd: "", //鉴定费
      agent: "", //经办人
      review: "", //复核
      finance: "", //财务
      token: "", //token

      daydate: "", //复核日期
    };
  },
  methods: {
    //提交复核
    cont_Submitjs() {
      this.$confirm("是否要复核订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("ass_ment").doc("' +
                this.id +
                '").update({data:{name:"' +
                this.input_jnames +
                '",deta:"' +
                this.deta +
                '",adds:"' +
                this.input_jadds +
                '",radio:"' +
                this.radiojs +
                '",input_tel:"' +
                this.input_jtels +
                '",input_wu:"' +
                this.input_jwus +
                '",input_idcard:"' +
                this.input_jidcards +
                '",tabs_inpus:"' +
                this.tabs_jinpus +
                '",tabs_inps:"' +
                this.tabs_jinps +
                '",tabs_ins:"' +
                this.tabs_jins +
                '",tabs_is:"' +
                this.tabs_jis +
                '",inputjd:"' +
                this.inputjd +
                '",agent:"' +
                this.agent +
                '",review:"' +
                this.review +
                '",finance:"' +
                this.finance +
                '",whether:true,reviewdate:"' +
                this.daydate +
                '"}})',
            })
            .then((refs) => {
              if (refs.data.errcode == 0) {
                this.$notify({
                  title: "复核成功",
                  message: "恭喜你，该订单已复核成功",
                  type: "success",
                });
                setTimeout(() => {
                  this.$router.push("/review");
                }, 2000);
              } else {
                this.$notify.error({
                  title: "错误",
                  message: "请检查token是否过期",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复核",
          });
        });
    },
    //请求数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("ass_ment").doc("' + this.id + '").get()',
        })
        .then((res) => {
          if(res.data.errcode !== 0){
            return  this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          (this.input_jnames = res.data.data[0].name),
            (this.deta = res.data.data[0].deta),
            (this.input_jadds = res.data.data[0].adds),
            (this.radiojs = res.data.data[0].radio),
            (this.input_jtels = res.data.data[0].input_tel),
            (this.input_jwus = res.data.data[0].input_wu),
            (this.input_jidcards = res.data.data[0].input_idcard),
            (this.tabs_jinputs = res.data.data[0].input_wu),
            (this.tabs_jinpus = res.data.data[0].tabs_inpus),
            (this.tabs_jinps = res.data.data[0].tabs_inps),
            (this.tabs_jins = res.data.data[0].tabs_ins),
            (this.tabs_jis = res.data.data[0].tabs_is),
            (this.inputjd = res.data.data[0].inputjd),
            (this.agent = res.data.data[0].agent);
          // (this.review = res.data.data[0].review),
          // (this.finance = res.data.data[0].finance);
        });
    },


  },
  //生命周期函数，监听页面加载
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
       //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()

    this.id = this.$route.query.id;

    //复核日期（今天的日期）
    this.daydate = dayjs().format("YYYY-MM-DD");
  },

  //生命周期函数，监听页面加载完成
  mounted() {
    setTimeout(()=>{
      this.getData();

      this.review = this.userData.username
    },800)
    
  },
};
</script>
<style scoped>
.cont_box {
  width: 75%;
  height: 95%;
  background-color: #ffffff;
  margin: 50px auto;
}
.cont_head {
  width: 100%;
  height: 40px;
  background-color: #eeeeed;
  box-shadow: 0 0 9px 0 #00000044;
  border: 1px solid #c5c5c5;
}
.cont_head h2 {
  margin: 3px 30px;
}
.bord {
  border: 0.5px solid #c5c5c5;
  margin-top: 4px;
}
.cont_bo {
  width: 100%;
  height: 95%;
  border: 1px solid #c5c5c5;
}
.cont_b {
  width: 99%;
  height: 99%;
  border: 1px solid #c5c5c5;
  margin: 4px auto;
  box-shadow: 0 0 9px 0 #00000044;
}
.cont_contes {
  width: 95%;
  border: 1px solid #8f8f8fdc;
  box-shadow: 0 0 9px 0 #00000044;
  margin: 45px auto;
}
.cons_cos {
  display: flex;
  flex-direction: row;
}
.cont_lefts {
  width: 50%;
  margin: 40px 80px;
}
.cont_rights {
  width: 50%;
  margin: 40px 0px;
}
.con_texts {
  width: 50%;
}
.tables {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}
.tab_item {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.cont_jb {
  margin: 10px 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.conts_zf {
  margin: 20px 0;
  display: flex;
  flex-direction: row;
}
.cont_jdf {
  width: 200px;
}
.conts_zf h3 {
  margin: 10px 25px;
}
.foter {
  margin: 30px 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
